import { MutableRefObject, useEffect, useRef, useState } from "react"
import { useNoteNames } from "../../Project/ProjectStore"
import { Modes } from "../../Util/Music/Modes"
import { Music } from "../../Util/Music/Music"
import { ClassNames } from "../../Util/ClassNames"
import { BsFilePlay, BsFillGearFill } from "react-icons/bs"
import { Capitalize } from "../../Util/Strings/Capitalize"
import './ModalSpectrumV2.scss'
import { useNotePlayer } from "../../Sound/SoundStore"
import { NotePlayer } from "../../Sound/NotePlayer"
import { Menu, SubMenu, MenuRadioGroup, MenuItem } from "@szhsin/react-menu"

export function ModalSpectrumV2(props:{relative:boolean, tonic:number, useSpectrum?:boolean}){
    const tonic:number = props.tonic
    const sequenceSpectrum:number = 0
    const sequenceNumeric:number = 1
    const [modalSequence, setModalSequence] = useState((props.useSpectrum) ? sequenceSpectrum : sequenceNumeric)
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const intervalNames:string[] = Music.IntervalNames
    const noteNames:string[] = useNoteNames()
    const [hilitedModes, setHilitedModes] = useState<number[]>([])
    const [hilitedIntervalColumns, setHilitedIntervalColumns] = useState<number[]>([])
    const [hilitedNotes, setHilitedNotes] = useState<number[]>([])
    const [noteLabels, setNoteLabels] = useState<boolean>(true)
    const [relativeModes, setRelativeModes] = useState<boolean>(props.relative)
    const getIntervalHeaders = () => {
        const getClassNames = (index:number) => {
            const classNames:ClassNames = new ClassNames(['interval-header'])
            if(hilitedIntervalColumns.includes(index)){classNames.addClass('hilited')}
            return classNames.toString()
        }
        return(
            <tr key={'header'}>
                <td></td>
                {intervalNames.map((name:string, index:number)=>{
                    return  <td className={getClassNames(index)} 
                                onClick={()=>{hiliteInterval(index)}} 
                                key={name + index}
                            >
                                {name}
                            </td>
                })}
            </tr>
        )
    }
    const ModalRows = () =>{
        const rows:JSX.Element[] = []
        const sequence:number[] = (modalSequence === sequenceNumeric) ? [0,1,2,3,4,5,6] :  Modes.SpectrumIndexes
        sequence.forEach((modeIndex:number, rowIndex:number)=>{
            rows.push(<ModalRow key={modeIndex} modalIndex={modeIndex} rowIndex={rowIndex}/>)
        })
        return(<>{rows}</>)
    }
    const hiliteMode = (modalIndex:number) => {
        if(!hilitedModes.includes(modalIndex)){
            setHilitedModes(hilitedModes.concat([modalIndex]))
            return
        }
        const index:number = hilitedModes.indexOf(modalIndex)
        const fresh_hilitedModes:number[] = hilitedModes.concat()
        fresh_hilitedModes.splice(index, 1)
        setHilitedModes(fresh_hilitedModes)
    }
    const hiliteInterval = (intervalIndex:number) => {
        if(!hilitedIntervalColumns.includes(intervalIndex)){
            setHilitedIntervalColumns(hilitedIntervalColumns.concat([intervalIndex]))
            return
        } 
        const index:number = hilitedIntervalColumns.indexOf(intervalIndex)
        const fresh_hilitedIntervals:number[] = hilitedIntervalColumns.concat()
        fresh_hilitedIntervals.splice(index, 1)
        setHilitedIntervalColumns(fresh_hilitedIntervals)
    }
    const getNoteId = (modalIndex:number, intervalIndex:number)=>{return (modalIndex * 100) + intervalIndex}
    const lastRowIndex:MutableRefObject<number> = useRef(-1)
    const onNoteClick = (rowTonic:number, activeRowIndex:number, modalIndex:number, intervalIndex:number, noteTonic:number, e:any) => {
        if(e.metaKey){ 
            if(lastRowIndex.current !== activeRowIndex){
                //alert(`new row: lastRowIndex.current = ${lastRowIndex.current} : activeRowIndex = ${activeRowIndex}`)
                lastRowIndex.current = activeRowIndex
                notePlayer.current.setTonic(rowTonic)
            }
            notePlayer.current.playNote(noteTonic, false) 
            return
        }
        hiliteNote(modalIndex, intervalIndex, noteTonic)
    }
    const hiliteNote = (modalIndex:number, intervalIndex:number, tonic:number) => {
        const noteId:number = getNoteId(modalIndex, intervalIndex)
        if(!hilitedNotes.includes(noteId)){
            setHilitedNotes(hilitedNotes.concat([noteId]))
            return
        } 
        const index:number = hilitedNotes.indexOf(noteId)
        const fresh_hilitedNotes:number[] = hilitedNotes.concat()
        fresh_hilitedNotes.splice(index, 1)
        setHilitedNotes(fresh_hilitedNotes)
    }
    const playMode = (rowTonic:number, modalIndex:number) => {
        const notes:number[] = (relativeModes) ? Modes.getModalScale(rowTonic, modalIndex, true) : Modes.getParallelModeScale(rowTonic, modalIndex, true)
        notePlayer.current.setTonic(rowTonic)
        notePlayer.current.playNotes(notes, true, 500)
    }
    const ModalRow = (props:{modalIndex:number, rowIndex:number}) =>{
        const rowTonic:number = (relativeModes) ? Music.getKeyScale(tonic)[props.modalIndex] : tonic
        const rowTonics:number[] = Music.getAllTonicsStartingAt(rowTonic, true)
        const cells:JSX.Element[] = [
            <td className={'name-cell'} key={props.modalIndex + 'name'}>
               <BsFilePlay onClick={()=>{
                playMode(rowTonic, props.modalIndex)
                }}/> 
               <span onClick={()=>{hiliteMode(props.modalIndex)}}> {`${props.modalIndex + 1} : ${Capitalize(Modes.Names[props.modalIndex])}`}</span>
            </td>
        ]
        const tonicsInMode:number[] = Modes.getParallelModeScale(rowTonic, props.modalIndex, true) //Modes.getParallelModeScale(rowTonic, props.modalIndex)
        rowTonics.forEach((tonic:number, columnIndex:number)=>{
            const noteScaleNumber:number = tonicsInMode.indexOf(tonic)
            if(noteScaleNumber === -1){
                cells.push(<td key={'name-' + tonic}></td>) 
                return
            }
            const getClassNames = () => {
                const classNames:ClassNames = new ClassNames(['interval-cell'])
                if(hilitedIntervalColumns.includes(columnIndex) || hilitedNotes.includes(getNoteId(props.modalIndex, columnIndex))){
                    classNames.addClass('hilited')
                }
                return classNames.toString()
            }
            const compKey:string = tonic + '-' + props.modalIndex + '-' + columnIndex
            const onClick = (e:React.MouseEvent) => {
                onNoteClick(rowTonic, props.rowIndex, props.modalIndex, columnIndex, tonic, e)
            }
            const label:string = (noteLabels) ? noteNames[tonic] : String(noteScaleNumber + 1)
            cells.push(<td onClick={onClick} key={compKey} className={getClassNames()}>
                            {label}
                        </td>)
        })
        const getRowClassNames = () => {
            const classNames:ClassNames = new ClassNames(['modal-row'])
            if(hilitedModes.includes(props.modalIndex)){
                classNames.addClass('hilited')
            }
            return classNames.toString()
        }
        return(
            <tr className={getRowClassNames()} key={props.modalIndex}>
                {cells}
            </tr>
        )
    }
    const clear = () => {
        setHilitedIntervalColumns([])
        setHilitedModes([])
        setHilitedNotes([])
    }
    useEffect(()=>{notePlayer.current.reset()}, [noteLabels, relativeModes])
    return(
        <div style={{width:800}}>
            <div className={'modal-spectrum'}>
                <h2>
                    Mode Type: {(relativeModes) ? 'Relative Modes' : 'Parallel Modes'}, Label Type: {(noteLabels) ? 'Note Names' : 'Position Numbers'}
                </h2>
                <table cellSpacing={0} className={'modal-spectrum-table'}>
                    <tbody>
                        {getIntervalHeaders()}
                        <ModalRows/>
                    </tbody>
                </table>
                <div className={'controls'}>
                    <button type='button' onClick={clear}>Clear</button>
                    <Menu menuButton={<button className={'setting-button'}>
                        <BsFillGearFill /> Settings</button>} transition>
                            <SubMenu label={'Order'}>
                                <MenuRadioGroup
                                        value={modalSequence}
                                        onRadioChange={(e:any)=>{setModalSequence(e.value)}}>
                                        <MenuItem type="radio" value={sequenceNumeric}>Position Number</MenuItem>
                                        <MenuItem type="radio" value={sequenceSpectrum}>Modal Spectrum</MenuItem>
                                </MenuRadioGroup>
                            </SubMenu>
                            <SubMenu label={'Mode Type'}>
                                <MenuRadioGroup
                                        value={relativeModes}
                                        onRadioChange={(e:any)=>{setRelativeModes(e.value)}}>
                                        <MenuItem type="radio" value={true}>Relative</MenuItem>
                                        <MenuItem type="radio" value={false}>Parallel</MenuItem>
                                </MenuRadioGroup>
                            </SubMenu>
                            <SubMenu label={'Label Type'}>
                            <MenuRadioGroup
                                    value={noteLabels}
                                    onRadioChange={(e:any)=>{setNoteLabels(e.value)}}>
                                    <MenuItem type="radio" value={false}>Position Numbers</MenuItem>
                                    <MenuItem type="radio" value={true}>Note Names</MenuItem>
                            </MenuRadioGroup>
                        </SubMenu>
                    </Menu>
                </div>
            </div>
        </div>
    )
}